<template>
    <div style="width: 100%">
        <div class="content-header black white--text font-weight-bold py-3 px-8 d-flex">
            <h2>User Dashboard</h2>

            <v-spacer />

            <v-btn
                v-if="inIframe"
                icon
                @click="closeModal">
                <v-icon color="white">
                    mdi-close
                </v-icon>
            </v-btn>
        </div>
        <div class="content-wrapper pa-3">
            <v-card-text
                style="font-size: 16px;"
                class="black--text">
                <v-row>
                    <v-col
                        cols="12"
                        sm="3"
                        color="info">
                        <ul class="sidebar-list pa-0 ma-0 ">
                            <li
                                v-for="item in sidebarItems"
                                :key="item.value"
                                class="sidebar-item"
                                :class="{active: currentItem === item.value}"
                                @click="currentItem = item.value">
                                <v-icon class="mr-3">
                                    {{ item.icon }}
                                </v-icon>
                                <span>{{ item.title }}</span>
                            </li>
                            <v-divider class="my-3" />
                            <li
                                class="sidebar-item"
                                @click="showSecurityInfo">
                                <v-icon class="mr-3">
                                    mdi-lock
                                </v-icon>
                                <span>Security</span>
                            </li>
                        </ul>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="9">
                        <v-card class="pa-2 tab-card">
                            <div
                                v-if="loading"
                                class="d-flex pa-3 justify-center align-center">
                                <v-progress-circular
                                    size="48"
                                    indeterminate />
                            </div>
                            <template v-else>
                                <div v-show="currentItem === 'personal-info'">
                                    <div class="black--text px-2">
                                        <h3 class="title py-3">
                                            Personal information
                                        </h3>
                                        <v-form
                                            ref="form"
                                            v-model="valid"
                                            lazy-validation>
                                            <v-row>
                                                <v-col cols="12">
                                                    <div
                                                        v-if="imageLoading"
                                                        class="pa-2">
                                                        <v-progress-circular indeterminate />
                                                    </div>
                                                    <label
                                                        v-else
                                                        for="avatarInput"
                                                        class="align-self-center subtitle-2 label-text">
                                                        <v-avatar size="50">
                                                            <v-icon
                                                                v-if="!avatar"
                                                                size="40"> mdi-account-plus </v-icon>
                                                            <div
                                                                style="
                                  width: 50px;
                                  height: 50px;
                                  background: linear-gradient(
                                    60deg,
                                    rgba(0, 0, 0, 0.8),
                                    rgba(0, 0, 0, 0.2)
                                  );
                                ">
                                                                <v-img
                                                                    v-if="avatar"
                                                                    :src="avatar"
                                                                    alt="Avatar" />
                                                            </div>
                                                        </v-avatar>
                                                        <input
                                                            id="avatarInput"
                                                            type="file"
                                                            class="d-none"
                                                            name="avatar"
                                                            @change="selectFile($event)">
                                                        <span class="ml-3">A photo helps personalize your account</span>
                                                    </label>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    class="py-0">
                                                    <v-text-field
                                                        v-model="formData.firstName"
                                                        label="First Name" />
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    class="py-0">
                                                    <v-text-field
                                                        v-model="formData.lastName"
                                                        label="Last Name" />
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="py-0">
                                                    <phone-number-input
                                                        v-model="formData.phoneNumber"
                                                        :required="true"
                                                        :label="'Phone number*'" />
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                        <div class="email-section">
                                            <div class="d-flex align-center mb-2 flex-wrap">
                                                <div class="text-no-wrap mr-3 mb-1">
                                                    <small class="mr-2">Email address</small>

                                                    <v-tooltip right>
                                                        <template #activator="{ on }">
                                                            <v-icon
                                                                color="red"
                                                                style="cursor: pointer"
                                                                v-on="on">
                                                                mdi-help-circle-outline
                                                            </v-icon>
                                                        </template>
                                                        Email address can be changed in the Security section
                                                    </v-tooltip>
                                                </div>
                                            </div>
                                            <p>{{ $store.getters.currentUserEmail }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="currentItem === 'my-bids'">
                                    <personal-info-my-bids />
                                </div>
                            </template>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions
                v-if="currentItem === 'personal-info'"
                class="mr-2">
                <v-spacer />
                <v-btn
                    class="black--text mr-4"
                    text
                    @click="closeModal">
                    Cancel
                </v-btn>
                <v-btn
                    class="black white--text"
                    :disabled="!valid"
                    @click="save">
                    Save
                </v-btn>
            </v-card-actions>
            <AppOverlaySpinner v-if="loadingWithOverlay" />
        </div>
    </div>
</template>


<script>
import AppOverlaySpinner from '@/components/App/AppOverlaySpinner';
import { Storage } from 'aws-amplify';
import PersonalInfoMyBids from '@/components/PersonalInfo/PersonalInfoMyBids';
import PhoneNumberInput from '@/components/UI/PhoneNumberInput';
import { Utils } from '@/utils';

export default {
    components: { PersonalInfoMyBids, AppOverlaySpinner, PhoneNumberInput },
    data() {
        return {
            valid: true,
            sidebarItems: [
                {
                    title: 'Personal Info',
                    icon: 'mdi-account',
                    value: 'personal-info',
                },
                {
                    title: 'My Bids',
                    icon: 'mdi-hand-right',
                    value: 'my-bids',
                },
            ],
            currentItem: 'personal-info',
            loading: true,
            loadingWithOverlay: false,
            formData: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                avatar: '',
            },
            imageLoading: false,
            avatar: null,
            rules: {
                required: (v) => !!v || 'Field is required',
            },
            inIframe: false,
        };
    },
    async created() {
        this.inIframe = window.top !== window.self;
        try {
            const tab = this.$route.query.tab;
            if (tab && this.sidebarItems.some((item) => item.value === tab)) {
                this.currentItem = tab;
            }

            const { data } = await this.$store.dispatch('fetchPersonalInfo');
            this.formData = data.getUser.personalInfo;
            if (this.formData.avatar) {
                const parsedKey = Utils.parseFileKey(this.formData.avatar);

                this.avatar = await Storage.get(parsedKey.key, {
                    level: parsedKey.level,
                    identityId: parsedKey.identityId,
                    bucket: this.$buckets.accounts,
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async save() {
            if (!this.$refs.form.validate()) return;

            try {
                this.loadingWithOverlay = true;
                await this.$store.dispatch('updatePersonalInfo', this.formData);
                this.loadingWithOverlay = false;
                this.$store.commit('snackbar', {
                    text: 'Personal info updated',
                    color: 'success',
                });
            } catch (e) {
                console.log(e);
            }
        },
        closeModal() {
            parent.postMessage('closePersonalInfoModal', '*');
        },
        showSecurityInfo() {
            const left = window.screen.width / 2 - 300;
            const top = window.screen.height / 2 - 250;
            window.open(
                `${window.location.origin}/#/security-info`,
                'Accounts',
                `height=600,width=500,top=${top},left=${left},
            location=yes,resizable=yes,scrollbars=yes,status=yes`,
            );
        },
        selectFile(e) {
            if (e.target.files[0]) {
                this.imageLoading = true;
                const file = e.target.files[0];

                const reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = (ev) => {
                    this.avatar = ev.target.result;
                };

                Storage.put(Utils.generateFileKey(file.type), file, {
                    level: 'protected',
                    contentType: file.type,
                    bucket: this.$buckets.accounts,
                })
                    .then(({ key }) => {
                        console.log(key);
                        this.formData.avatar = `protected/${localStorage.getItem('identityId')}/${key}`;
                    })
                    .catch((err) => console.log(err))
                    .finally(() => (this.imageLoading = false));
            }
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar-list {
    list-style: none;

    .sidebar-item {
        padding: 10px 15px;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.54);
        font-size: 0.875rem;
        font-weight: 500;
        &.active {
            background-color: #eeeeee;
            color: #000000;
        }

        &:hover:not(.active) {
            opacity: 0.5;
            cursor: pointer;
            transition: 0.2s;
        }
    }
}

.content-wrapper {
    padding-top: 60px !important;
    height: calc(100vh - 70px);
    width: 100%;
    position: relative;
}

.tab-card {
    overflow: hidden;
}

.email-info {
    padding: 2px 15px;
    background-color: #bbbbbb;
}

.label-text {
    color: #4d4d4d;
    cursor: pointer;
}
</style>